import React, {useEffect, useState} from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import {FixedSizeList} from 'react-window';
import SearchBox from '../SearchBox';
import JString from '@easytech-international-sdn-bhd/jstring';
import {sanitize_regx} from '../../Helper/Helper';
import {makeStyles} from '@material-ui/core';
import './style.css';

const useStyles = makeStyles((theme) => ({
	countChip: {
		display: 'inline-flex',
		alignItems: 'baseline',
		justifyContent: 'flex-end',
		flexShrink: 0,
		marginLeft: 8,
		minWidth: 56,
		padding: '3px 9px',
		borderRadius: 999,
		backgroundColor: theme.palette.action.selected
	},
	countChipSelected: {
		backgroundColor: theme.palette.primary.main
	},
	countNum: {
		fontSize: 13,
		fontWeight: 700,
		lineHeight: 1,
		letterSpacing: 0.2,
		color: theme.palette.text.primary,
		fontVariantNumeric: 'tabular-nums'
	},
	countNumSelected: {
		color: '#1a1800'
	},
	countUnit: {
		marginLeft: 5,
		fontSize: 10,
		fontWeight: 600,
		lineHeight: 1,
		letterSpacing: 0.4,
		textTransform: 'uppercase',
		color: theme.palette.text.secondary
	},
	countUnitSelected: {
		color: 'rgba(26,24,0,0.6)'
	}
}));

export default function FixedList({ listData, onClick, height = 500, selected, counts, countLabel }){
	const classes = useStyles();
	const [ listItems, setListItems ] = useState([]);
	useEffect(()=>{
		setListItems(listData);
	},[listData]);

	const renderRow = (props) => {
		const { index, style } = props;
		const obj = listItems[index];

		return index !== listItems.length ? (
			<ListItem
				button
				selected={selected == obj?.value}
				style={{ ...style }}
				key={index}
				onClick={()=>{
					// setTappedItem(obj);
					onClick && onClick(obj);
				}}>
				<ListItemText
					primary={obj?.name}
					primaryTypographyProps={{ noWrap: true }}/>
				{counts && (
					<span className={selected == obj?.value ? `${classes.countChip} ${classes.countChipSelected}` : classes.countChip}>
						<span className={selected == obj?.value ? `${classes.countNum} ${classes.countNumSelected}` : classes.countNum}>
							{counts?.[obj?.value] ?? 0}
						</span>
						{countLabel ? (
							<span className={selected == obj?.value ? `${classes.countUnit} ${classes.countUnitSelected}` : classes.countUnit}>
								{countLabel}
							</span>
						) : null}
					</span>
				)}
			</ListItem>
		):null;
	}

	const onSearchList = (text) =>{
		if(text){
			const newArr = [];
			const query = String(sanitize_regx(text));
			for (let i = 0; i < listData.length; i++) {
				const obj = listData[i];
				const { value, key, name } = obj;
				if(
					// JString(value).searchDeep(query) ||
					// JString(key).searchDeep(query) ||
					JString(name).searchDeep(query)
				){
					newArr.push(obj);
				}
			}
			setListItems(newArr);
		}else{
			setListItems(listData);
		}
	}

	return (
		<div>
			<SearchBox
				onChangeText={(e)=>{onSearchList(e)}}
			/>
			<FixedSizeList
				margin={10}
				height={height}
				width='100%'
				itemSize={80}
				itemCount={listData ? listData.length : 0}
				style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
				className="hide-scrollbar"
				>
				{renderRow}
			</FixedSizeList>
		</div>
	)
}
